import { render, staticRenderFns } from "./async-button.vue?vue&type=template&id=56982acc&"
import script from "./async-button.vue?vue&type=script&lang=ts&"
export * from "./async-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports